import "./style.css";
import { ButtroidsApp } from "./app";
import { COPY } from "./config/brand";

const root = document.querySelector<HTMLElement>("#app");
if (!root) throw new Error("Application root not found");
const appRoot = root;

let fallbackShown = false;

function showFallback(error: unknown): void {
  if (fallbackShown) return;
  fallbackShown = true;
  console.error(COPY.ui.error.log, error);
  appRoot.innerHTML = `
    <main class="error-fallback" role="alert" aria-labelledby="error-title">
      <div aria-hidden="true">🫧</div>
      <p>${COPY.ui.error.kicker}</p>
      <h1 id="error-title">${COPY.ui.error.title}</h1>
      <p>${COPY.ui.error.explanation}</p>
      <button type="button" id="reload-game">${COPY.ui.error.retry}</button>
    </main>
  `;
  appRoot
    .querySelector<HTMLButtonElement>("#reload-game")
    ?.addEventListener("click", () => globalThis.location.reload());
}

globalThis.addEventListener("error", (event) => showFallback(event.error));
globalThis.addEventListener("unhandledrejection", (event) =>
  showFallback(event.reason),
);

try {
  new ButtroidsApp().mount(appRoot);
} catch (error) {
  showFallback(error);
}
